import React, { memo } from "react"
import { useStore } from "../../teafuljs/store"
import GetSegment from "../../scripts/NavigateToSegment"

const List = memo(({ content, type, id }) => {
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
  const [refID, setRefID] = useStore.refID()
  const [currentBook, setCurrentBook] = useStore.currentBook()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const styles = {
    paragraph: {
      margin: "5px 0",
    },
    link: {
      textDecoration: "underline",
      color: "blue",
    },
  }

  const navigateToRef = obj => {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])

    const segment = GetSegment(obj.book, obj.chapter, obj.verse)
    setCurrentSegmentID(segment)
    setCurrentBook(obj.book)
    setRefID("")
    setSearchID(`${obj.book}-${obj.chapter}-${obj.verse}`)
  }

  if (type === "bulleted-list") {
    return (
      <div style={styles.paragraph}>
        <ul>
          {content.map((li, lIndex) => (
            <li key={`bulleted-list-${id}-${lIndex}`}>
              {li.children.map((leaf, leafIndex) => {
                const { link } = leaf
                return (
                  <span
                    key={`bulleted-list-${id}-${lIndex}-${leafIndex}`}
                    style={link ? styles.link : {}}
                    onClick={link ? () => navigateToRef(link) : () => {}}
                  >
                    {leaf.text}
                  </span>
                )
              })}
            </li>
          ))}
        </ul>
      </div>
    )
  }
  if (type === "numbered-list") {
    return (
      <div style={styles.paragraph}>
        <ol>
          {content.map((li, lIndex) => (
            <li key={`numbered-list-${id}-${lIndex}`}>
              {li.children.map((leaf, leafIndex) => {
                const { link } = leaf
                return (
                  <span
                    key={`numbered-list-${id}-${lIndex}-${leafIndex}`}
                    style={link ? styles.link : {}}
                    onClick={link ? () => navigateToRef(link) : () => {}}
                  >
                    {leaf.text}
                  </span>
                )
              })}
            </li>
          ))}
        </ol>
      </div>
    )
  }
})

export default List
